import { render, staticRenderFns } from "./Contador.vue?vue&type=template&id=674331f5&scoped=true&lang=pug&"
import script from "./Contador.vue?vue&type=script&lang=js&"
export * from "./Contador.vue?vue&type=script&lang=js&"
import style0 from "./Contador.styl?vue&type=style&index=0&id=674331f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674331f5",
  null
  
)

export default component.exports